import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  constructor(private translocoService: TranslocoService) {}

  init(): Promise<any> {
    const lang = 'en';
    this.translocoService.setDefaultLang(lang);
    this.translocoService.setActiveLang(lang);
    return this.translocoService
      .load(lang)
      .toPromise()
      .then(() => this.translocoService.load('global/' + lang).toPromise())
      .then(() => this.translocoService.load('login/' + lang).toPromise())
      .then(() => this.translocoService.load('navigation/' + lang).toPromise())
      .then(() => this.translocoService.load('error/' + lang).toPromise());
  }
}
